import React from "react";
import Page from "~/shared/Page";
import useNavbar from "./use-navbar";
import FloatingPanel from "~/shared/FloatingPanel";
import FormButton from "~/shared/form/FormButton";

export default function TutoringPaymentPage() {
    return (
        <Page title="Tutoring Payments" navBar={useNavbar()}>
            <div className="page-container">
                <FloatingPanel title="Pay for Tutoring Services">
                    <p className="max-w-3xl mx-auto">
                        We are committed to providing quality tutoring services to help you achieve academic success.
                        Your payment helps support our efforts and ensures that we can continue offering top-notch education.
                        Thank you for choosing us to help you in your learning journey.
                    </p>
                    <FormButton formless as="a" family className="mx-auto" target="_blank" rel="noopener noreferrer" href="https://www.paypal.com/webapps/shoppingcart?flowlogging_id=f4965472933d4&mfid=1746719232229_f4965472933d4#/checkout/openButton">
                        Pay for Tutoring Now
                    </FormButton>
                </FloatingPanel>
            </div>
        </Page>
    );
}
